<template>
  <div class="sms-input">
    <i-input
      ref="input"
      type="textarea"
      :maxlength="max_length"
      :rows="4"
      :value="value"
      v-on="$listeners"
      @input="cursor_position"
    />
    <div class="sms-input__info">
      <div class="row">
        <div class="col">
          {{ $t('shared.component.sms_input.sms_count', { count: counter.messages }) }}
        </div>
        <div class="col text-right">
          {{
            $t('shared.component.sms_input.letter_count', {
              count: value.length,
              total: max_length
            })
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CounterSMS } from '@/plugins/sms-counter';
  const LIMIT_MESSAGES = 5;

  export default {
    props: {
      value: {
        type: String,
        default: ''
      }
    },

    computed: {
      counter() {
        return CounterSMS.count(this.value);
      },

      max_length: function() {
        return this.counter.per_message * LIMIT_MESSAGES;
      }
    },

    methods: {
      cursor_position() {
        try {
          return this.$refs.input.$refs.textarea.selectionStart;
        } catch (e) {
          return 0;
        }
      }
    }
  };
</script>

<style lang="scss">
  .sms-input {
    .ivu-input {
      &:hover,
      &:focus {
        box-shadow: none;
        border-color: $grey-dark;
        outline: none;
      }
    }

    &__info {
      padding: $spacer/4 $spacer/2;
      background: $grey;
      color: $blue-grey-light;
      font-size: 12px;
      border: 1px solid $grey-dark;
      margin-top: -2px;
    }
  }
</style>
